module.exports = __webpack_public_path__ + "static/media/queen.3c41c5d3.png";